<template>
  <section>
    <Paragraph class="font-jost-regular text-blue-dark text-[25px] leading-[30px] mt-10" text="Verification" />
    <div class="t-results text-lg mt-5">
      <section class="t-results-body grid grid-cols-2 gap-[90px] bg-white">
        <div>
          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              Block
            </div>
            <router-link v-if="transactionData && transactionData.uvt && transactionData.uvt.uvtData"
              class="col block px-2.5 flex relative text-[#5B6BD5] cursor-pointer"
              :to="{ name: 'block', params: { chainNumber: transactionData.uvt.uvtData.chainNumber || $route.params.chainNumber || $route.params.chain, blockNumber: transactionData.uvt.uvtData.blockNumber } }">
              #{{ transactionData.uvt.uvtData.blockNumber }}
            </router-link>
          </div>

          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              Transaction Fee
            </div>
            <div class="col font-jost-regular px-2.5 text-blue-dark">
              {{ transactionFee }} <span v-if="transactionFee !== 'N/A'" class="uppercase">GEEQ</span>
            </div>
          </div>

          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              Timestamp
            </div>
            <div class="col font-jost-regular px-2.5 text-blue-dark">
              {{ getTxCreationDate() }}
            </div>
          </div>

          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              Coin amount
            </div>
            <div class="col flex px-2.5 gap-[10px]">
              <p class="block relative text-ellipsis text-[#5B6BD5] cursor-pointer">
                {{ transactionData.uvt.uvtData.amtCoin }} GEEQ
              </p>
            </div>
          </div>

          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              From
            </div>
            <div class="col flex px-2.5 gap-[10px]">
              <router-link v-if="sender" class="block text-ellipsis text-[16px]"
                :to="{ name: 'account', params: { chainNumber: transactionData.uvt.uvtData.chainNumber || transactionData.uat.uatData.chainNumber || $route.params.chainNumber || $route.params.chain, address: sender } }">
                <span class="text-[#5B6BD5]">
                  {{ sender }}
                </span>
              </router-link>
              <CopyIcon :isActive="checkIfIsEqual(sender, 'sender')" @click="copy(sender, 'sender')" title="Copy hash"
                class="min-w-[16px] h-[19px] inline-block cursor-pointer align-top" />
            </div>
          </div>

          <div class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              To
            </div>
            <div class="col flex px-2.5 gap-[10px]">
              <router-link v-if="receiver" class="block text-ellipsis text-[16px]"
                :to="{ name: 'account', params: { chainNumber: transactionData.uvt.uvtData.chainNumber || transactionData.uat.uatData.chainNumber || $route.params.chainNumber || $route.params.chain, address: receiver } }">
                <span class="text-[#5B6BD5]">
                  {{ receiver }}
                </span>
              </router-link>
              <CopyIcon :isActive="checkIfIsEqual(receiver, 'receiver')" @click="copy(receiver, 'receiver')" title="Copy hash"
                class="min-w-[16px] h-[19px] inline-block cursor-pointer align-top" />
            </div>
          </div>
        </div>

        <div>
          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              Chain Number
            </div>
            <div class="col">
              {{ transactionData.uvt.uvtData.chainNumber }}
            </div>
          </div>
          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              Status
            </div>
            <div class="flex items-center gap-3 col font-jost-regular px-2.5">
              <span class="px-2 py-1 text-base font-medium rounded uppercase" 
                  :class="transactionData.status === 'valid' ? 'bg-green-100 text-green-800' : 
                    transactionData.status === 'invalid' ? 'bg-red-100 text-red-800' : 
                    'bg-yellow-100 text-yellow-800'">
                {{ transactionData.status || 'PENDING' }}
              </span>
            </div>
          </div>
          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              Signature
            </div>
            <div class="col flex items-center font-jost-regular px-2.5">
              <p v-if="transactionData" class="block text-ellipsis text-[16px]">
                <span class="text-blue-dark">
                  {{ transactionData.signature }}
                </span>
              </p>
              <CopyIcon :isActive="checkIfIsEqual(transactionData.signature, 'signature')" @click="copy(transactionData.signature, 'signature')"
                title="Copy hash" class="min-w-[16px] h-[19px] inline-block cursor-pointer align-top" />
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>

</template>

<script>
import moment from 'moment';
import string from '@/helpers/string';

import CopyIcon from "@/components/svg/CopyIcon.vue";
import Paragraph from "@/components/web/ParagraphComponent";

export default {
  name: 'CreateProxyMintOverview',
  components: {
    CopyIcon,
    Paragraph
  },
  props: {
    transactionData: {
      type: Object,
      required: true
    },
    transactionRefHash: {
      type: String,
      required: true
    },
  },
  computed: {
    transactionFee() {
      const fee = this.transactionData?.fee
        ?? this.transactionData?.uat?.overview?.fee
        ?? this.transactionData?.uat?.uatData?.fee;

      return fee === null || fee === undefined || fee === '' ? 'N/A' : fee;
    },
    sender() {
      const sender = this.transactionData.uvt.uvtData.from;
      return sender || '';
    },
    receiver() {
      const receiver = this.transactionData.uvt.uvtData.to;
      return receiver || '';
    },
  },
  data() {
    return {
      copied: '',
    };
  },
  methods: {
    copy(hash, uId = 0) {
      string.copyToClipboard(hash);
      this.setCopied(hash + uId);
    },
    setCopied(hash) {
      this.copied = hash;
    },
    checkIfIsEqual(str, uId = 0) {
      return string.isTextEqualTo(str, this.copied, uId);
    },
    getTxCreationDate() {
      const createdAt = this.transactionData.uvt.uvtData.createdAt;
      if (!createdAt) {
        return '';
      }
      return moment(createdAt).format('YYYY-MM-DD HH:mm:ss');
    },
  }
}
</script>

<style>
.transaction-explorer .vjs-value {
  color: #2699FB !important;
  font-size: 18px;
  line-height: 26px;
  font-family: 'Jost-Regular', monospace !important;
}

.transaction-explorer .vjs-tree {
  font-size: 18px;
  line-height: 26px;
  overflow-x: auto !important;
  white-space: nowrap;
  color: #2699FB !important;
}

.transaction-explorer .vjs-key {
  font-family: 'Jost-Regular', monospace !important;
  color: #2699FB !important;
}
</style>
<style scoped>
.col {
  flex: 1;
  /* distributes space on the line equally among items */
  width: calc(100% / 2);
}

.t-results-body {
  padding: 28px 21px;
  border-radius: 8px;
}

.t-results-body .row:first-child {
  border-top: unset;
}

@media (max-width: 992px) {
  .t-results-body {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .first__col__last__row {
    border-bottom: 1px solid #2699FB;
  }
}
</style>
